<template>
  <v-card class="mx-auto" width="300" tile>
    <v-navigation-drawer v-model="toggle" app>
      <v-sheet color="grey lighten-4" class="pa-4">
        <v-avatar class="mb-1" color="grey darken-1" size="64"></v-avatar>
        <v-list nav>
          <v-list-item link @click="ItemAction({action: 'profile'})">
            <v-list-item-content>
              <v-list-item-title class="text-h6">
                {{ user.cve_empleado }} - {{user.usuario}}
              </v-list-item-title>
              <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-sheet>
      <v-divider/>
      <v-list>
        <v-list-item @click="menu('home')">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-subtitle class="font-weight-bold black--text">Inicio</v-list-item-subtitle>
        </v-list-item>

        <v-list-item @click="menu('dashboard')">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-subtitle class="font-weight-bold black--text">Dashboard</v-list-item-subtitle>
        </v-list-item>

        <span v-for="(action, index) in menuGral" :key="index">
          <ListGroupitem v-if="action.group" :item="action" :on-success="ItemAction"/>
          <ListItem v-else :item="action" :on-success="ItemAction" main="si"/>
        </span>
      </v-list>

    </v-navigation-drawer>
  </v-card>
</template>

<script>
import router from '@/router'
import ListItem from '@/components/core/menu/ListItem'
import ListGroupitem from '@/components/core/menu/ListGroupitem'
import { Permission } from '@/mixins/permissionMain'
export default {
  props: {
    toggle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [Permission],
  data: () => ({
    user: {},
    menuGral: [
      {
        id: 'recursoshumanos',
        icon: 'mdi-account-group',
        title: 'RH',
        hidden: 'hiddenItem',
        group: true,
        items: [
          {
            id: 'rh.empleados-show',
            action: 'ViewRHEmpleados',
            icon: 'mdi-account',
            title: 'Empleados',
            hidden: 'hiddenItem'
          },
          {
            id: 'rh-catalogos',
            icon: 'mdi-cogs',
            title: 'Catalogos',
            hidden: 'hiddenItem',
            group: true,
            items: [
              {
                id: 'nomina-config-categorias.show',
                action: 'ViewNomConfigCategorias',
                icon: 'mdi-folder-multiple',
                title: 'Categorias',
                hidden: 'hiddenItem'
              },
              {
                id: 'nomina-config-plazas.show',
                action: 'ViewNomConfigPlazas',
                icon: 'mdi-account',
                title: 'Plazas',
                hidden: 'hiddenItem'
              },
              {
                id: 'nomina-config-puestos.show',
                action: 'ViewNomConfigPuestos',
                icon: 'mdi-account-network',
                title: 'Puestos',
                hidden: 'hiddenItem'
              },
              {
                id: 'config.niveles-show',
                action: 'ViewNomConfigNiveles',
                icon: 'mdi-chart-box-outline',
                title: 'Niveles',
                hidden: 'hiddenItem'
              }
            ]
          }
        ]
      },
      {
        id: 'asistencia',
        icon: 'mdi-account-multiple-check',
        title: 'Asistencia',
        hidden: 'hiddenItem',
        group: true,
        items: [
          {
            id: 'asist.logapp-show',
            action: 'ViewLogApplication',
            icon: 'mdi-apps-box',
            title: 'Aplicaciones',
            hidden: 'hiddenItem'
          },
          {
            id: 'asist.asistencia-show',
            action: 'ViewNomConfigAsistencia',
            icon: 'mdi-account-check',
            title: 'Asistencias',
            hidden: 'hiddenItem'
          },
          {
            id: 'asist.cargahorarios-show',
            action: 'ViewHorarioAsistencias',
            icon: 'mdi-account-check',
            title: 'Horarios',
            hidden: 'hiddenItem'
          },
          {
            id: 'asist.resumenhoras-show',
            action: 'ViewNomConfigIncidencias',
            icon: 'mdi-account-check',
            title: 'Resumen de Horas',
            hidden: 'hiddenItem'
          }
        ]
      },
      {
        id: 'nomina.show',
        icon: 'mdi-clipboard-text',
        title: 'Nomina',
        hidden: 'hiddenItem',
        group: true,
        items: [
          {
            id: 'nomina.nominas-show',
            action: 'ViewNomNominaGeneradas',
            icon: 'mdi-account-cash-outline',
            title: 'Nominas',
            hidden: 'hiddenItem'
          },
          {
            id: 'nomina.cuentas-show',
            action: 'ViewNomConfigCuentasEmpleados',
            icon: 'mdi-account-cash-outline',
            title: 'Cuentas Bancarias',
            hidden: 'hiddenItem'
          }
        ]
      },
      {
        id: 'configuracion',
        icon: 'mdi-cogs',
        title: 'Configuracion General',
        hidden: 'hiddenItem',
        group: true,
        items: [
          {
            id: 'config.import-data',
            action: 'ExaImport',
            icon: 'mdi-archive-arrow-down',
            title: 'Importador',
            hidden: 'hiddenItem'
          },
          {
            id: 'configuracion.auth',
            icon: 'mdi-book-multiple',
            title: 'Accesos',
            hidden: 'hiddenItem',
            group: true,
            items: [
              {
                id: 'config-auth-usuarios.show',
                action: 'ViewConfigAuthUsers',
                icon: 'mdi-account',
                title: 'usuarios',
                hidden: 'hiddenItem'
              },
              {
                id: 'config-auth-roles.show',
                action: 'ViewConfigAuthRols',
                icon: 'mdi-account-network',
                title: 'roles',
                hidden: 'hiddenItem'
              },
              {
                id: 'config-auth-permisos.show',
                action: 'ViewConfigAuthPermiss',
                icon: 'mdi-account-check',
                title: 'Permisos',
                hidden: 'hiddenItem'
              }
            ]
          },
          {
            id: 'config.company',
            icon: 'mdi-book-multiple',
            title: 'Empresa',
            hidden: 'hiddenItem',
            group: true,
            items: [
              {
                id: 'config-company-departamentos.show',
                action: 'ViewConfigDepartments',
                icon: 'mdi-account',
                title: 'Departamentos',
                hidden: 'hiddenItem'
              },
              {
                id: 'config-company-ejercicios.show',
                action: 'ViewConfigEjercicios',
                icon: 'mdi-account',
                title: 'Ejercicios',
                hidden: 'hiddenItem'
              }
            ]
          }
        ]
      }
    ]
  }),
  components: {
    ListItem,
    ListGroupitem
  },
  mounted () {
    this.user = this.$cookies.get('user_sirh')
    this.PermisosMenu(JSON.parse(localStorage.getItem('permisos')), this.menuGral)
  },
  methods: {
    ItemAction (item) {
      router.push({ name: item.action })
    },
    menu (item) {
      router.push({ name: item })
    }
  }
}
/*
  modulos
  recuros humanos
  empleados
  Adscripciones => dentro del proceso de nomina
  Cuentas empleados => dentro del proceso
  nomina
  catalogos
  bancos.
  Pagos
  asistencias
*/
</script>

<style>
.relleno {
  color: white;
  background: #bf360c;
}
.title-menu {
  color: white;
  font-size: 20px !important;
  max-width: 100% !important;
  height: 38px !important;
  text-align: center !important;
}
.hiddenItem{
  display: none;
}
</style>
